import React from 'react';
import styled from 'styled-components';

const flowchartUrl = '/flowchart.svg';
const OfferSection = styled.section`
  padding: 4rem 2rem;
  background-color: #ffffff;
  text-align: center;
`;

const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 2.25rem;
  color: #333;
  margin-bottom: 1.5rem;
`;

const SectionParagraph = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.7;
  margin-bottom: 3rem;
  max-width: 750px; /* Constrain paragraph width for readability */
  margin-left: auto;
  margin-right: auto;
`;

const FlowchartImage = styled.img`
  max-width: 100%;
  height: auto;
`;

const WhatWeOffer = () => {
  return (
    <OfferSection>
      <ContentWrapper>
        <SectionTitle>What we offer</SectionTitle>
        <SectionParagraph>
          We offer a variety of private letters within 24 hours to help with sick notes and student exam exemptions. Our experienced UK based doctors will review your request and provide the letter within 24 hours. See how the system works below.
        </SectionParagraph>
        <FlowchartImage src={flowchartUrl} alt="Our process flowchart: request, review, receive" />
      </ContentWrapper>
    </OfferSection>
  );
};

export default WhatWeOffer;